/**
 * The cached UserProfile. Never null — worst case it is EMPTY_PROFILE, so no
 * screen has to null-guard it.
 */

import { EMPTY_PROFILE, normalizeStoredUser } from "./consumerMappers";

const PROFILE_KEY = "sayagie.profile";

let cached = null;
const listeners = new Set();

const notify = () => listeners.forEach((listener) => listener(getProfile()));

export const getProfile = () => {
  if (cached) return cached;

  try {
    const raw = localStorage.getItem(PROFILE_KEY);
    cached = raw ? normalizeStoredUser(JSON.parse(raw)) : EMPTY_PROFILE;
  } catch {
    cached = EMPTY_PROFILE;
  }

  return cached;
};

export const setProfile = (profile) => {
  cached = normalizeStoredUser(profile);

  try {
    localStorage.setItem(PROFILE_KEY, JSON.stringify(cached));
  } catch {
    /* storage unavailable — the in-memory copy still serves this page */
  }

  notify();
  return cached;
};

export const clearProfile = () => {
  cached = null;

  try {
    localStorage.removeItem(PROFILE_KEY);
  } catch {
    /* nothing to do */
  }

  notify();
};

export const onProfileChange = (listener) => {
  listeners.add(listener);
  return () => listeners.delete(listener);
};

/** A stub row — tokens landed but `consumers/save/` never completed. */
export const isStubProfile = (profile) =>
  !profile?.firstName && !profile?.dateOfBirth && !profile?.address;
